import Tooltip from "components/Tooltip";
import { useTranslation } from "react-i18next";

const ExportToolMenu = ({
  disabled,
  hidden,
}: {
  disabled?: boolean;
  hidden?: boolean;
}) => {
  const { t } = useTranslation();

  if (hidden) return null;

  return (
    <Tooltip
      content={
        disabled ? t("buildingMaterialResources.exportNoLicenseTooltip") : ""
      }
      className={disabled ? "!cursor-not-allowed" : "cursor-pointer"}
    >
      <div className="text-gray-900 font-[400]">{"DGNB Master Tool"}</div>
    </Tooltip>
  );
};

export default ExportToolMenu;
